import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';

export default function GlowingOutlineBox({ size = [1, 1, 1], highlighted = false, showBase = false }) {
  const pulseRef = useRef();

  // Pulsing scale effect when highlighted
  useFrame(({ clock }) => {
    if (highlighted && pulseRef.current) {
      const t = clock.getElapsedTime();
      const pulse = 1 + 0.02 * Math.sin(t * 4);
      pulseRef.current.scale.set(pulse, pulse, pulse);
    }
  });

  const edgeThickness = 0.03;
  const [width, height, depth] = size;

  // Inline material avoids shared state bugs
  const makeEdge = (position, scale) => (
    <mesh position={position}>
      <boxGeometry args={scale} />
      <meshStandardMaterial color="#ffaa00" emissive="#ffaa00" emissiveIntensity={3} toneMapped={false} transparent opacity={0.9} depthWrite={false} />
    </mesh>
  );

  const edges = [
    // vertical edges (corners)
    makeEdge([width / 2, height / 2, depth / 2], [edgeThickness, height, edgeThickness]),
    makeEdge([-width / 2, height / 2, depth / 2], [edgeThickness, height, edgeThickness]),
    makeEdge([width / 2, height / 2, -depth / 2], [edgeThickness, height, edgeThickness]),
    makeEdge([-width / 2, height / 2, -depth / 2], [edgeThickness, height, edgeThickness]),
    // horizontal bottom edges
    makeEdge([0, 0, depth / 2], [width, edgeThickness, edgeThickness]),
    makeEdge([0, 0, -depth / 2], [width, edgeThickness, edgeThickness]),
    makeEdge([width / 2, 0, 0], [edgeThickness, edgeThickness, depth]),
    makeEdge([-width / 2, 0, 0], [edgeThickness, edgeThickness, depth])
  ];

  return (
    <group ref={pulseRef}>
      {/* Semi-transparent base box, only when requested or highlighted to avoid ghost outlines */}
      {(showBase || highlighted) && (
        <mesh position={[0, height / 2, 0]}>
          <boxGeometry args={[width, height, depth]} />
          <meshStandardMaterial color="#e6e3e3" transparent opacity={0.2} depthWrite={false} />
        </mesh>
      )}

      {/* Glowing outline edges, only when highlighted */}
      {highlighted && edges}
    </group>
  );
}
